import React from "react";
import { Input } from "semantic-ui-react";

import "./filterData.scss";

export default function FilterData({
  label,
  placeholder,
  disabled,
  value,
  onChange,
}) {
  return (
    <div className="inputFilter">
      <label>{label}</label>{" "}
      <Input
        value={value}
        placeholder={placeholder}
        disabled={disabled}
        onChange={(e, data) => onChange(data?.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.preventDefault(); 
          }
        }}
      />
    </div>
  );
}
